module.exports = __webpack_public_path__ + "img/carousel1.96126ddd.jpeg";